var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacilityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#B7E3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_27291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5807 19.25H28.4141V17.4167H26.5807V19.25ZM26.5807 22.9167H28.4141V21.0833H26.5807V22.9167ZM26.5807 26.5833H28.4141V24.75H26.5807V26.5833ZM26.5807 30.25V28.4167H30.2474V15.5833H21.9974V16.8667L20.1641 15.5375V13.75H32.0807V30.25H26.5807ZM11.9141 30.25V21.0833L18.3307 16.5L24.7474 21.0833V30.25H19.2474V25.6667H17.4141V30.25H11.9141ZM13.7474 28.4167H15.5807V23.8333H21.0807V28.4167H22.9141V22L18.3307 18.7458L13.7474 22V28.4167Z",
    fill: "#1C1B1F"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon);
export default __webpack_public_path__ + "static/media/facility-icon.b970af9a854ee7acaa70644d3de9fa3a.svg";
export { ForwardRef as ReactComponent };